import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dashboard_onsite",
  "use": "dashboard_onsite-usage",
  "viewBox": "0 0 30 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 28\" id=\"dashboard_onsite\"><path clip-rule=\"evenodd\" d=\"M1.013 2.504a1.5 1.5 0 011.5-1.5h25a1.5 1.5 0 011.5 1.5v23a1.5 1.5 0 01-1.5 1.5h-25a1.5 1.5 0 01-1.5-1.5v-23z\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M1.013 7.004h28M23.013 13.004v8a2 2 0 01-2 2h-12a2 2 0 01-2-2v-8\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M23.013 13.004a2 2 0 00-2-2h-12a2 2 0 00-2 2l6.94 4.339a2 2 0 002.12 0l6.94-4.339z\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/dashboard_onsite.svg
// module id = m/jx
// module chunks = 39 44